import React, { useState } from 'react';
import { motion } from 'framer-motion';

const locations = [
  { id: 1, name: 'القيادة العامة للشرطة', x: '40%', y: '30%', color: 'bg-blue-500', shadow: 'shadow-[0_0_15px_blue]' },
  { id: 2, name: 'المستشفى المركزي', x: '60%', y: '45%', color: 'bg-red-500', shadow: 'shadow-[0_0_15px_red]' },
  { id: 3, name: 'الميناء (منطقة تهريب)', x: '80%', y: '70%', color: 'bg-neon-purple', shadow: 'shadow-[0_0_15px_#bc13fe]' },
];

export default function RadarMap() {
  const [activeLoc, setActiveLoc] = useState(null);

  return (
    <section id="الرادار" className="pt-32 pb-24 min-h-screen bg-black flex flex-col items-center justify-center relative">
      <h2 className="text-4xl font-bold mb-10 text-white">رادار <span className="text-neon-cyan">المقاطعة</span></h2>
      
      <div className="relative w-[300px] h-[300px] md:w-[500px] md:h-[500px] rounded-full border-2 border-neon-cyan/30 bg-[linear-gradient(rgba(0,243,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(0,243,255,0.1)_1px,transparent_1px)] bg-[size:20px_20px] overflow-hidden shadow-neon">
        
        {/* خطوط الرادار */}
        <div className="absolute top-1/2 left-0 w-full h-[1px] bg-neon-cyan/30"></div>
        <div className="absolute top-0 left-1/2 w-[1px] h-full bg-neon-cyan/30"></div>
        <div className="absolute inset-4 rounded-full border border-neon-cyan/10"></div>
        <div className="absolute inset-16 rounded-full border border-neon-cyan/20"></div>
        
        {/* حركة المسح (Sweep) */}
        <div className="absolute inset-0 rounded-full radar-sweep"></div>

        {/* النقاط على الخريطة */}
        {locations.map((loc) => (
          <div
            key={loc.id}
            className="absolute z-20 cursor-pointer"
            style={{ left: loc.x, top: loc.y }}
            onMouseEnter={() => setActiveLoc(loc.name)}
            onMouseLeave={() => setActiveLoc(null)}
          >
            <div className={`w-4 h-4 rounded-full ${loc.color} ${loc.shadow} animate-ping absolute`}></div>
            <div className={`w-4 h-4 rounded-full ${loc.color} relative`}></div>
          </div>
        ))}
      </div>

      {/* شاشة المعلومات الهولوغرامية */}
      <div className="mt-10 h-16 flex items-center justify-center">
        {activeLoc ? (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="px-6 py-2 border border-neon-cyan bg-neon-cyan/10 text-neon-cyan font-mono tracking-widest rounded-md uppercase">
            TARGET ACQUIRED: {activeLoc}
          </motion.div>
        ) : <span className="text-gray-600 font-mono">SCANNING FOR SIGNALS...</span>}
      </div>
    </section>
  );
}